import { render } from "./FeedbackPopup.vue?vue&type=template&id=0c958a58&scoped=true"
import script from "./FeedbackPopup.vue?vue&type=script&lang=js"
export * from "./FeedbackPopup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0c958a58"

export default script